import { invokeEdgeFunction } from './supabaseEdge'

/**
 * Run full production AI digest (awaits pipeline completion).
 * @returns {Promise<{ ok: boolean, status?: number, error?: string, body?: Record<string, unknown> }>}
 */
export async function runDigestBriefing() {
  try {
    const res = await invokeEdgeFunction('basecamp-agents-run', {
      method: 'POST',
      body: JSON.stringify({ all_digest: true }),
    })
    const body = await res.json().catch(() => ({}))
    if (!res.ok) {
      return {
        ok: false,
        status: res.status,
        error: (body && body.error) || res.statusText || 'Digest failed',
        body,
      }
    }
    return { ok: true, status: res.status, body }
  } catch (e) {
    return { ok: false, error: e?.message || 'Unknown error' }
  }
}

/** @deprecated Use runDigestBriefing */
export const triggerDigestCron = runDigestBriefing

/**
 * @param {{ ok: boolean, error?: string, body?: Record<string, unknown> }} result
 * @returns {{ type: 'success' | 'error', text: string }}
 */
export function formatDigestBriefingMessage(result) {
  if (!result.ok) {
    return { type: 'error', text: result.error || 'Digest failed' }
  }
  const body = result.body || {}
  if (body.skipped === 'no_links_with_delta') {
    return {
      type: 'success',
      text: 'Briefing finished — no new recordings or comments since watermark for any enabled link.',
    }
  }
  if (body.email_sent) {
    const n = Array.isArray(body.links_included) ? body.links_included.length : 0
    return {
      type: 'success',
      text: n > 0 ? `Briefing complete — email sent (${n} link(s)).` : 'Briefing complete — email sent.',
    }
  }
  if (body.email_error) {
    return {
      type: 'error',
      text: `Briefing finished but email failed: ${String(body.email_error)}`,
    }
  }
  const n = Array.isArray(body.links_included) ? body.links_included.length : 0
  return {
    type: 'success',
    text: n > 0 ? `Briefing complete (${n} link(s) processed).` : 'Briefing complete.',
  }
}
